module.exports = __webpack_public_path__ + "static/img/rppghealthappbs3.1f7adb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/rppghealthappbs3.png
// module id = Iv8k
// module chunks = 5